import { cx } from "class-variance-authority";

import { Typography } from "../Typography/Typography";

import * as styles from "./Divider.module.scss";

type DividerProps = Partial<{
  orientation: "horizontal" | "vertical";
  content: string | false;
}>;

const Divider = ({
  orientation = "horizontal",
  content = "OR",
}: DividerProps) => (
  <div
    className={cx(styles.divider, {
      [styles.vertical]: orientation === "vertical",
    })}
  >
    {content && (
      <Typography variant="body" noSpacing>
        {content}
      </Typography>
    )}
  </div>
);

Divider.displayName = "Divider";

export { Divider };
